 export function convertYouTubeURL(inputURL) {
    // Regular expression to extract the video ID
    var regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    // Extract video ID from input URL
    var match = inputURL.match(regex);
    if (!match || !match[1]) {
      return "Invalid YouTube URL";
    }

    // Construct the output URL with desired parameters
    var videoID = match[1];
    // var outputURL = "https://www.youtube.com/embed/" + videoID + "?autoplay=1&controls=1&loop=1&mute=1&playlist=" + videoID;
    // setvideoID(videoID);
    return videoID;
  }